import React from "react";
import { filterImage } from "../../assets";
import "date-fns";
import ActiveRequests from "./components/Active-Requests/ActiveRequests";
import { useState, useEffect } from "react";
import CancelRequests from "./components/Cancel-Requests/CancelRequests";
import DoneRequests from "./components/Done-Requests/DoneRequests";
import ActiveFilter from "./components/Active-Requests/ActiveFilter";
import CancelRequestsFilter from "./components/Cancel-Requests/CancelRequestsFilter";
import DoneRequestFilter from "./components/Done-Requests/DoneRequestFilter";
import { SearchableDropdown } from "../../components";
import FilterChips from "./components/FilterChips";
import { TIMELINE_STATUS_OPTIONS } from "../../ui_libs/constants";

function MyRequests() {
  const [filter, setfilter] = useState();
  const [activeFilterTitles, setActiveFilterTitles] = useState([]);
  const [doneFilterTitles, setDoneFilterTitles] = useState([]);
  const [cancelFilterTitles, setCancelFilterTitles] = useState([]);
  const [status, setStatus] = useState(
    localStorage.getItem("myReqActiveStatus")
      ? `${localStorage.getItem("myReqActiveStatus")}`
      : ""
  );
  const [doneStatus, setDoneStatus] = useState(
    localStorage.getItem("myReqDoneStatus")
      ? `${localStorage.getItem("myReqDoneStatus")}`
      : ""
  );
  const [requestType, setRequestType] = useState(
    localStorage.getItem("myReqType")
      ? localStorage.getItem("myReqType")
      : "active"
  );
  const [counts, setCounts] = useState({
    activeCount: 0,
    doneCount: 0,
    cancelCount: 0,
  });
  useEffect(() => {
    localStorage.setItem("myReqType", requestType);
  }, [requestType]);
  useEffect(() => {
    localStorage.setItem("myReqActiveStatus", status);
  }, [status]);
  useEffect(() => {
    localStorage.setItem("myReqDoneStatus", doneStatus);
  }, [doneStatus]);
  return (
    <>
      <section id="content-wrapper" className="content-wrapper calendar-page">
        <div className="container-fluid min-width-650">
          <p className="small-text-bold page-title">REQUESTS</p>
          <div className="calendar-wrapper mt-20 pb-30">
            <div className="row justify-content-center">
              <div className="col-12 col-lg-8 mb-3">
                <SearchableDropdown />
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-8 text-left">
                <div className="status-buttons mb-3">
                  <span
                    onClick={() => setRequestType("active")}
                    className={
                      requestType === "active"
                        ? "custom-btn-small custom-button-extra-small req-status-button req-active active"
                        : "custom-btn-small custom-button-extra-small req-status-button filter-button req-active"
                    }
                  >
                    Active ({counts.activeCount})
                  </span>
                  <span
                    onClick={() => setRequestType("cancelled")}
                    className={
                      requestType === "cancelled"
                        ? "custom-btn-small custom-button-extra-small req-status-button filter-button req-cancelled  active"
                        : "custom-btn-small custom-button-extra-small req-status-button filter-button req-cancelled "
                    }
                  >
                    Cancelled ({counts.cancelCount})
                  </span>
                  <span
                    onClick={() => setRequestType("done")}
                    className={
                      requestType === "done"
                        ? "custom-btn-small custom-button-extra-small req-status-button filter-button req-done mt-2 mt-sm-0 active"
                        : "custom-btn-small custom-button-extra-small req-status-button filter-button req-done mt-2 mt-sm-0"
                    }
                  >
                    Done ({counts.doneCount})
                  </span>

                  <div className="clearfix"></div>
                </div>
              </div>
              <div className="col-4 text-right">
                  <span
                    className="black-color pointer-point"
                    data-toggle="modal"
                    data-target="#change-filter"
                  >
                    <img src={filterImage} />
                    <span className="pl-2">Filter</span>
                  </span>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                {requestType === "active" && (
                  <select
                    className="form-control form-control-sm w-75"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    {TIMELINE_STATUS_OPTIONS.slice(0, 6).map((option) => (
                      <option value={option.value}>{option.label}</option>
                    ))}
                  </select>
                )}
                {requestType === "done" && (
                  <select
                    className="form-control form-control-sm w-75"
                    value={doneStatus}
                    onChange={(e) => setDoneStatus(e.target.value)}
                  >
                    <option value={""}>{"All Done Requests"}</option>
                    {TIMELINE_STATUS_OPTIONS.slice(7, 9).map((option) => (
                      <option value={option.value}>{option.label}</option>
                    ))}
                  </select>
                )}
              </div>
              <div className="col-6">
                {requestType === "active" && (
                  <FilterChips titles={activeFilterTitles} />
                )}
                {requestType === "done" && (
                  <FilterChips titles={doneFilterTitles} />
                )}
                {requestType === "cancelled" && (
                  <FilterChips titles={cancelFilterTitles} />
                )}
              </div>
            </div>
            {/* // */}
            {requestType === "active" && (
              <ActiveRequests
                setActiveFilterTitles={setActiveFilterTitles}
                counts={counts}
                status={status}
                setCounts={setCounts}
              />
            )}
            {requestType === "cancelled" && (
              <CancelRequests
                setCancelFilterTitles={setCancelFilterTitles}
                counts={counts}
                setCounts={setCounts}
              />
            )}
            {requestType === "done" && (
              <DoneRequests
                setDoneFilterTitles={setDoneFilterTitles}
                counts={counts}
                status={doneStatus}
                setCounts={setCounts}
              />
            )}
          </div>
        </div>
      </section>
      {/* {requestType === "active" && <ActiveFilter />} */}
      {/* {requestType === "cancelled" && <CancelRequestsFilter />} */}
      {/* {requestType === "done" && <DoneRequestFilter />} */}
    </>
  );
}

export default MyRequests;
